import staticData from '../../static_data/all';

if (typeof window !== 'undefined' && !staticData.useStatic) {
    window.twttr = (function(d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0],
            t = window.twttr || {};
        if (d.getElementById(id)) return t;
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://platform.twitter.com/widgets.js';
        fjs.parentNode.insertBefore(js, fjs);

        t._e = [];
        t.ready = function(f) {
            t._e.push(f);
        };

        return t;
    })(document, 'script', 'twitter-wjs');
}

const getTwitterShareUrl = (
    tweetText,
    twitterMention,
    postalCode,
    partnerName,
    publisherName,
    articleUrl,
    hideSymbol
) => {
    const text = tweetText
        .replace(/@localRepresentative/g, '')
        .replace(/@twitterMentionPlaceholder/g, twitterMention || '@Speakable')
        .replace(/@postalCodePlaceholder/g, postalCode || '')
        .replace(/@partnerTwitterMention/g, partnerName || '')
        .replace(/@publisherTwitterMention/g, publisherName || '')
        .replace(/@articleUrl/g, articleUrl || '')
        .replace(/@/g, hideSymbol ? '' : '@')
        .replace(/<span id="partnerName">/g, '')
        .replace(/<\/span>/g, '');
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
};

export default getTwitterShareUrl;
